import { MutableRefObject } from 'react'

import { CursorState } from '@editor/config/constants/cursor'
import { RectangleMeshProps } from '@editor/interfaces/canvas/rectangleMesh'
import { BlueprintEditorTools } from '@editor/pages/projects/blueprint-editor/definitions'
import { RootState, useAppDispatch } from '@editor/store/app'
import { setCurrentAnchorPosition, setCursor, setHoveredElementId, setSelectedElementIds } from '@editor/store/tool'
import { ThreeEvent } from '@react-three/fiber'
import { useSelector } from 'react-redux'
import { Vector2 } from 'three'

const useEventHandlers = (
  { id }: RectangleMeshProps,
  isDraggingRef: MutableRefObject<boolean>,
  movingStartLocalPointRef: MutableRefObject<Vector2 | null>,
) => {
  // Store
  const dispatch = useAppDispatch()
  const editingElementId = useSelector((state: RootState) => state.toolUtil.core.editingElementId)
  const selectedTool = useSelector((state: RootState) => state.blueprint.editor.selectedTool)

  const isSelectedTool = selectedTool === BlueprintEditorTools.Rectangle
  const isSelectorTool = selectedTool === BlueprintEditorTools.Selector

  const handleMouseEnter = (ev: ThreeEvent<MouseEvent>) => {
    if (editingElementId) return

    ev.stopPropagation()
    dispatch(setCurrentAnchorPosition(undefined))
    dispatch(setHoveredElementId(id))
    dispatch(setCursor(CursorState.MOVE))
  }

  const handleMouseLeave = (ev: ThreeEvent<MouseEvent>) => {
    ev.stopPropagation()
    dispatch(setHoveredElementId(''))
    dispatch(setCursor(isSelectedTool ? CursorState.CROSSHAIR : CursorState.DEFAULT))
  }

  const handleMouseDown = (ev: ThreeEvent<MouseEvent>) => {
    ev.stopPropagation()
    movingStartLocalPointRef.current = new Vector2(ev.clientX, ev.clientY)
  }

  const handleClick = (ev: ThreeEvent<MouseEvent>) => {
    if (isDraggingRef.current || !isSelectorTool) return

    ev.stopPropagation()
    dispatch(setSelectedElementIds([id]))
  }

  return {
    handleMouseEnter,
    handleMouseLeave,
    handleMouseDown,
    handleClick,
  }
}

export default useEventHandlers
